import { workplaceSettingsConstants as wsc } from 'srcReact/WorkplaceSettingsPage'

const initialState = {
  manage_invites: {
    loading: false,
    loaded: false,
    error: '',
    status: '',
    invitations: [],
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    }
  },
  leadership_team: [],
  loading: false,
  loaded: false,
  success: false,
  workplace_members: {
    loading: false,
    loaded: false,
    error: '',
    members: [],
    members_stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    }
  },
  general_groups: {
    loading: false,
    loaded: false,
    groups: [],
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    }
  },
  member_led_groups: {
    loading: false,
    loaded: false,
    groups: [],
    stats: {
      total: 0,
      next_offset: 0,
      remaining: 0
    }
  },
  workplace_list: [],
  display: {
    loading: false,
    loaded: false,
    success: false,
    id: 0,
    name: '',
    accronym: '',
    color: '',
    location: {
      id: 0,
      workplace_id: 0,
      latitude: 0,
      longitude: 0,
      name: null,
      google_place_id: '',
      formatted_address: '',
      street_number: '',
      route: '',
      postal_code: '',
      locality: '',
      area_level_1: '',
      area_level_2: '',
      country: '',
      utc_offset: null,
      created_at: '',
      updated_at: ''
    },
    righs_permissions: {
      can_create_groups: 0,
      can_create_public_groups: 0,
      can_create_private_groups: 0
    }
  }
}

export function workplaceSettings(state = initialState, action) {
  switch (action.type) {
    case wsc.GET_WORKPLACE_LIST_SUCCESS:
      return {
        ...state,
        workplace_list: action.data?.workplace_list
      }

    case wsc.GET_WORKPLACE_MANAGE_INVITES_REQUEST: {
      const { status } = action.data
      return {
        ...state,
        manage_invites: {
          ...state.manage_invites,
          loading: true,
          loaded: false,
          invitations: status !== state.manage_invites.status ? [] : state.manage_invites.invitations,
          status: status,
          error: ''
        }
      }
    }
    case wsc.GET_WORKPLACE_MANAGE_INVITES_SUCCESS: {
      const {
        workplace_settings: { manage_invites },
        status,
        isPagination
      } = action.data
      return {
        ...state,
        manage_invites: {
          ...state.manage_invites,
          invitations:
            status === 'invitation_from_entity' && isPagination
              ? [...state.manage_invites.invitations, ...manage_invites.invitations]
              : action.data?.workplace_settings?.manage_invites?.invitations,
          stats: {
            ...state.manage_invites.stats,
            ...action.data?.workplace_settings?.manage_invites?.stats
          },
          loading: false,
          loaded: true,
          error: ''
        }
      }
    }
    case wsc.GET_WORKPLACE_MANAGE_INVITES_FAILURE:
      return {
        ...state,
        manage_invites: {
          ...state.manage_invites,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case wsc.ADD_WORKPLACE_MEMBER_ROLE_SUCCESS:
      const addedWorkplaceMembers = action.data?.users || []
      const updateInvitationsAdded = state.manage_invites.invitations.map((item) => {
        const matchedMember = addedWorkplaceMembers?.find((member) => member?.id === item?.member?.id)
        if (matchedMember) {
          return {
            ...item,
            workplace_role: matchedMember?.roles
              ?.reverse()
              .map((r) => r?.role)
              ?.join(', ')
          }
        } else {
          return item
        }
      })
      const updateLeadershipTeamAdded = state.leadership_team.map((item) => {
        const matchedMember = addedWorkplaceMembers?.find((member) => member?.id === item?.manager_id)
        if (matchedMember) {
          return {
            ...item,
            roles: matchedMember?.roles
              ?.reverse()
              .map((r) => r?.role)
              ?.join(', ')
          }
        } else {
          return item
        }
      })
      const updateMembersAdded = state.workplace_members.members.map((item) => {
        const matchedMember = addedWorkplaceMembers?.find((member) => member?.id === item?.user_id)
        if (matchedMember) {
          return {
            ...item,
            roles: matchedMember?.roles
              ?.reverse()
              .map((r) => r?.role)
              ?.join(', ')
          }
        } else {
          return item
        }
      })
      return {
        ...state,
        leadership_team: updateLeadershipTeamAdded,
        success: true,
        loading: false,
        manage_invites: {
          ...state.manage_invites,
          invitations: updateInvitationsAdded
        },
        workplace_members: {
          ...state.workplace_members,
          members: updateMembersAdded
        }
      }

    case wsc.REMOVE_WORKPLACE_MEMBER_ROLE_SUCCESS:
      const removedWorkplaceMembers = action.data?.users || []
      const updateInvitationsRemoved = state.manage_invites.invitations.map((item) => {
        const matchedMember = removedWorkplaceMembers?.find((member) => member?.id === item?.member?.id)
        if (matchedMember) {
          return {
            ...item,
            workplace_role: matchedMember?.roles
              ?.reverse()
              .map((r) => r?.role)
              ?.join(', ')
          }
        } else {
          return item
        }
      })
      const updateLeadershipTeamRemoved = state.leadership_team
        .map((item) => {
          const matchedMember = removedWorkplaceMembers?.find((member) => member?.id === item?.manager_id)
          if (!matchedMember) {
            return item
          }
          return null
        })
        .filter((item) => item !== null)
      const updateMembersRemoved = state.workplace_members.members.map((item) => {
        const matchedMember = removedWorkplaceMembers?.find((member) => member?.id === item?.user_id)
        if (matchedMember) {
          return {
            ...item,
            roles: matchedMember?.roles
              ?.reverse()
              .map((r) => r?.role)
              ?.join(', ')
          }
        } else {
          return item
        }
      })
      return {
        ...state,
        leadership_team: updateLeadershipTeamRemoved,
        manage_invites: {
          ...state.manage_invites,
          invitations: updateInvitationsRemoved
        },
        workplace_members: {
          ...state.workplace_members,
          members: updateMembersRemoved
        }
      }

    case wsc.REMOVE_WORKPLACE_MEMBER_SUCCESS:
      return {
        ...state,
        manage_invites: {
          ...state.manage_invites,
          invitations: [...state.manage_invites.invitations.filter((i) => i?.member?.id !== action.data?.user_id)]
        },
        workplace_members: {
          ...state.workplace_members,
          members: [...state.workplace_members.members.filter((i) => i?.user_id !== action.data?.user_id)]
        }
      }

    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_REQUEST:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: true,
          loaded: false
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_SUCCESS:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          members: action.data?.workplace_settings?.workplace_members?.members,
          members_stats: {
            ...state.workplace_members.members_stats,
            ...action.data?.workplace_settings?.workplace_members?.members_stats
          },
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_FAILURE:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_REQUEST:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: true
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_SUCCESS:
      const nextSettingsMembersIds = new Set(
        action.data?.workplace_settings?.workplace_members?.members?.map((m) => m.user_id)
      )
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          members: [
            ...state.workplace_members.members.filter((m) => !nextSettingsMembersIds.has(m.user_id)),
            ...action.data?.workplace_settings?.workplace_members?.members
          ],
          members_stats: {
            ...state.workplace_members.members_stats,
            ...action.data?.workplace_settings?.workplace_members?.members_stats
          },
          loading: false
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_FAILURE:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: false
        }
      }

    case wsc.GET_WORKPLACE_MEMBERS_REQUEST:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: true,
          loaded: false
        }
      }
    case wsc.GET_WORKPLACE_MEMBERS_SUCCESS:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          members: action.data?.workplace_members?.members,
          members_stats: {
            ...state.workplace_members.members_stats,
            ...action.data?.workplace_members?.members_stats
          },
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_MEMBERS_FAILURE:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_MEMBERS_PAGINATION_REQUEST:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: true
        }
      }
    case wsc.GET_WORKPLACE_MEMBERS_PAGINATION_SUCCESS:
      const nextMembersIds = new Set(action.data?.workplace_members?.members?.map((m) => m.user_id))
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          members: [
            ...state.workplace_members.members.filter((m) => !nextMembersIds.has(m.user_id)),
            ...action.data?.workplace_members?.members
          ],
          members_stats: {
            ...state.workplace_members.members_stats,
            ...action.data?.workplace_members?.members_stats
          },
          loading: false
        }
      }
    case wsc.GET_WORKPLACE_MEMBERS_PAGINATION_FAILURE:
      return {
        ...state,
        workplace_members: {
          ...state.workplace_members,
          loading: false
        }
      }

    case wsc.GET_WORKPLACE_SETTINGS_REQUEST:
      return {
        ...state,
        display: {
          ...state.display,
          loading: true,
          loaded: false
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_SUCCESS:
      return {
        ...state,
        display: {
          ...state.display,
          ...action.data?.workplace_settings?.display,
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_SETTINGS_FAILURE:
      return {
        ...state,
        display: {
          ...state.display,
          loading: false,
          loaded: true
        }
      }

    case wsc.UPDATE_WORKPLACE_REQUEST:
      return {
        ...state,
        display: {
          ...state.display,
          loading: true,
          loaded: false,
          success: false
        }
      }
    case wsc.UPDATE_WORKPLACE_SUCCESS:
      const updatedWorkplace = action.data?.workplace
      const updatedWorkplaceList = state.workplace_list.map((item) =>
        item.id === updatedWorkplace.id ? { ...item, ...updatedWorkplace } : item
      )
      return {
        ...state,
        display: {
          ...state.display,
          ...action.data?.workplace,
          accronym: action.data?.workplace?.initials,
          loading: false,
          loaded: true,
          success: true
        },
        workplace_list: updatedWorkplaceList
      }
    case wsc.UPDATE_WORKPLACE_FAILURE:
      return {
        ...state,
        display: {
          ...state.display,
          loading: false,
          loaded: false,
          success: false
        }
      }

    case wsc.UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_SUCCESS:
      return {
        ...state,
        display: {
          ...state.display,
          righs_permissions: {
            ...state.display.righs_permissions,
            ...action.data?.workplace?.righs_permissions
          }
        }
      }

    case wsc.GET_WORKPLACE_GROUPS_REQUEST:
      return {
        ...state,
        general_groups: {
          ...state.general_groups,
          loading: true,
          loaded: false
        },
        member_led_groups: {
          ...state.member_led_groups,
          loading: true,
          loaded: false
        }
      }
    case wsc.GET_WORKPLACE_GROUPS_SUCCESS:
      return {
        ...state,
        general_groups: {
          ...state.general_groups,
          groups: action.data?.workplace_settings?.general_groups?.groups,
          stats: {
            ...state.general_groups.stats,
            ...action.data?.workplace_settings?.general_groups?.stats
          },
          loading: false,
          loaded: true
        },
        member_led_groups: {
          ...state.general_groups,
          groups: action.data?.workplace_settings?.member_led_groups?.groups,
          stats: {
            ...state.member_led_groups.stats,
            ...action.data?.workplace_settings?.member_led_groups?.stats
          },
          loading: false,
          loaded: true
        }
      }
    case wsc.GET_WORKPLACE_GROUPS_FAILURE:
      return {
        ...state,
        general_groups: {
          ...state.general_groups,
          loading: false,
          loaded: true
        },
        member_led_groups: {
          ...state.member_led_groups,
          loading: false,
          loaded: true
        }
      }

    case wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_REQUEST:
      return {
        ...state,
        member_led_groups: {
          ...state.member_led_groups,
          loading: true
        }
      }
    case wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_SUCCESS:
      const nextMemberLedGroupsIds = new Set(
        action.data?.workplace_settings?.member_led_groups?.groups?.map((g) => g.group_id)
      )
      return {
        ...state,
        member_led_groups: {
          ...state.member_led_groups,
          groups: [
            ...state.member_led_groups.groups.filter((g) => !nextMemberLedGroupsIds.has(g.group_id)),
            ...action.data?.workplace_settings?.member_led_groups?.groups
          ],
          stats: {
            ...state.member_led_groups.stats,
            ...action.data?.workplace_settings?.member_led_groups?.stats
          },
          loading: false
        }
      }
    case wsc.GET_WORKPLACE_MEMBER_LED_GROUPS_FAILURE:
      return {
        ...state,
        member_led_groups: {
          ...state.member_led_groups,
          loading: false
        }
      }

    case wsc.GET_WORKPLACE_LEADERSHIP_TEAM_REQUEST:
      return {
        ...state,
        success: false,
        loading: true,
        loaded: false
      }
    case wsc.GET_WORKPLACE_LEADERSHIP_TEAM_SUCCESS:
      return {
        ...state,
        leadership_team: action.data?.workplace_settings?.leadership_team,
        loading: false,
        loaded: true
      }
    case wsc.GET_WORKPLACE_LEADERSHIP_TEAM_FAILURE:
      return {
        ...state,
        success: false,
        loading: false,
        loaded: true
      }

    case wsc.GET_RIGHTS_PERMISSIONS_SUCCESS:
      return {
        ...state,
        righs_permissions: {
          ...state.righs_permissions,
          ...action.data?.workplace_settings?.righs_permissions
        }
      }

    case wsc.DELETE_WORKPLACE_INVITATION_SUCCESS:
      return {
        ...state,
        manage_invites: {
          ...state.manage_invites,
          invitations: [...state.manage_invites.invitations.filter((i) => i?.id !== action.data?.invitation_id)]
        }
      }

    default:
      return state
  }
}
